export default __webpack_public_path__ + "static/media/WORLD_LANGUAGES_GERMAN.b0bf897f.svg";